<div class="vault-page-shell" *ngIf="configService.vaultProfileConfigSubject | async as vaultProfile">
  <div class="space-y-6">
    <a [routerLink]="'/dashboard/accounts'" id="search-back" class="vault-back-link">
      <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
      Back to accounts
    </a>

    <div class="vault-page-header">
      <div class="space-y-3">
        <p class="vault-page-kicker">TEFCA discovery</p>
        <div class="space-y-2">
          <h1 class="vault-page-title">Add a healthcare provider</h1>
          <p class="vault-page-copy max-w-2xl">
            We found these providers through TEFCA based on your verified identity. Connect the ones you want added to your vault.
          </p>
        </div>
      </div>
    </div>
    <div class="vault-divider"></div>

    <section class="vault-panel p-5 sm:p-6">
      <div class="rounded-2xl border border-blue-200 bg-blue-50 px-4 py-4 text-sm text-slate-700">
        <p class="font-semibold text-slate-900">Verified through TEFCA</p>
        <p class="mt-1">
          Providers marked “Connect now” can be added immediately. Others may need you to sign in with the provider first.
        </p>
      </div>

      <div *ngIf="errorMessage" class="mt-4 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
        {{ errorMessage }}
      </div>
    </section>

    <section class="vault-panel overflow-hidden">
      <div class="border-b border-slate-100 px-4 py-4 sm:px-5">
        <div class="flex items-center justify-between gap-4">
          <div>
            <h2 class="text-lg font-semibold text-slate-900">Available providers</h2>
            <p class="mt-1 text-sm text-slate-500">
              {{ (vaultProfile.connectedPatientAccounts || []).length }} connected,
              {{ ((vaultProfile.discoveredPatientAccounts || {}) | keyvalue).length + ((vaultProfile.pendingPatientAccounts || {}) | keyvalue).length }} available
            </p>
          </div>
          <div *ngIf="loading" class="text-sm font-medium text-[#5B47FB]">Loading providers...</div>
        </div>
      </div>

      <div class="p-3 sm:p-4">
        <ng-container *ngIf="!loading; else loadingState">
          <div class="divide-y divide-slate-100">
            <div
              *ngFor="let discoveredAccount of ((vaultProfile.discoveredPatientAccounts || {}) | keyvalue)"
              class="vault-list-row">
              <div class="flex w-full flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex items-center gap-4">
                  <img
                    imageFallback
                    [src]="'https://cdn.fastenhealth.com/logos/sources/' + discoveredAccount.value.brand?.id + '.png'"
                    [alt]="discoveredAccount.value.portal?.name || discoveredAccount.value.brand?.name"
                    class="h-12 w-12 rounded-lg border border-slate-200 bg-white object-contain p-2">
                  <div class="space-y-1">
                    <p class="font-semibold text-slate-900">{{ discoveredAccount.value.portal?.name || discoveredAccount.value.brand?.name }}</p>
                    <p class="text-sm text-slate-500">Ready to connect now through TEFCA.</p>
                  </div>
                </div>
                <button
                  type="button"
                  class="vault-primary-button"
                  [disabled]="!!authorizingVaultConnectionId"
                  (click)="connectDiscoveredAccount(discoveredAccount.key, discoveredAccount.value)">
                  {{ authorizingVaultConnectionId === discoveredAccount.key ? 'Connecting...' : 'Connect now' }}
                </button>
              </div>
            </div>

            <div
              *ngFor="let pendingAccount of ((vaultProfile.pendingPatientAccounts || {}) | keyvalue)"
              class="vault-list-row">
              <div class="flex w-full flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex items-center gap-4">
                  <img
                    imageFallback
                    [src]="'https://cdn.fastenhealth.com/logos/sources/' + pendingAccount.value.brand?.id + '.png'"
                    [alt]="pendingAccount.value.portal?.name || pendingAccount.value.brand?.name"
                    class="h-12 w-12 rounded-lg border border-slate-200 bg-white object-contain p-2">
                  <div class="space-y-1">
                    <p class="font-semibold text-slate-900">{{ pendingAccount.value.portal?.name || pendingAccount.value.brand?.name }}</p>
                    <p class="text-sm text-slate-500">A provider sign-in is still required before records can be added.</p>
                  </div>
                </div>
                <button
                  type="button"
                  class="vault-secondary-button"
                  [disabled]="!!authorizingVaultConnectionId"
                  (click)="connectPendingAccount(pendingAccount.key, pendingAccount.value)">
                  Sign in to connect
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="emptyTefcaResults" class="rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-6 py-8 text-center">
            <h3 class="text-lg font-semibold text-slate-900">No TEFCA providers found</h3>
            <p class="mt-2 text-sm leading-6 text-slate-500">
              We couldn’t find any providers to add right now. You can refresh this page and try again later.
            </p>
          </div>
        </ng-container>

        <ng-template #loadingState>
          <div class="rounded-2xl border border-slate-200 bg-slate-50 px-6 py-8 text-center text-sm text-slate-500">
            Finding providers from TEFCA for your account...
          </div>
        </ng-template>
      </div>
    </section>
  </div>
</div>
